export const ROUTES = {
    HOME: '/',
    ERROR_PAGE : '/errorPage',
    DISPLAY_CARD : '/displayCard',
    CONFIRMATION : '/confirmation',
    TIMEOUT : '/timeout'
}